import {
  bootstrapEegDetachedWindowDocument,
  syncDetachedWindowLocation,
  waitForDetachedShellRoot,
  type BootstrapEegDetachedWindowOptions,
} from "./eegDetachedWindowBootstrap";

export function buildEegDetachedWindowUrl(options: {
  panelKey: string;
  title: string;
}): string {
  const url = new URL("/eeg-detached.html", window.location.origin);
  url.searchParams.set("panel", options.panelKey);
  url.searchParams.set("title", options.title);
  return url.toString();
}

export interface OpenEegDetachedWindowOptions
  extends BootstrapEegDetachedWindowOptions {
  windowName: string;
  width: number;
  height: number;
}

export function openEegDetachedWindow(
  options: OpenEegDetachedWindowOptions,
): Window | null {
  const url = buildEegDetachedWindowUrl(options);
  const win = window.open(
    url,
    options.windowName,
    `width=${options.width},height=${options.height},resizable=yes,scrollbars=no`,
  );
  if (!win) return null;

  syncDetachedWindowLocation(win, options);

  void waitForDetachedShellRoot(win).then((root) => {
    if (!root || win.closed) return;
    bootstrapEegDetachedWindowDocument(win, {
      title: options.title,
      panelKey: options.panelKey,
      compactToolbar: options.compactToolbar,
    });
  });

  return win;
}

export {
  computeAnnotationListViewportHeightPx,
  computeCompactAnnotationToolbarPopoutHeightPx,
  EEG_ANNOTATION_LIST_VISIBLE_ROWS,
  EEG_ANNOTATION_ROW_GAP_PX,
  EEG_ANNOTATION_ROW_HEIGHT_PX,
} from "./eegDetachedWindowMetrics";

export { waitForDetachedShellRoot, syncDetachedWindowLocation };
